export const selectGlobalApiFailure = (state) => state.notifications.globalError
